// src/apiBase.js
export const API_BASE =
  process.env.REACT_APP_API_URL ||
  process.env.REACT_APP_API_BASE ||
  (process.env.NODE_ENV === "production"
    ? "https://nutrafox-backend.onrender.com"
    : "http://localhost:5000");
